import { useParams, Link } from "react-router-dom";
import { useRef, useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { mangaCategories, mangaList } from "@/mocks/manga";

const categoryCoverImages: Record<string, string> = {
  rexue: "https://readdy.ai/api/search-image?query=Epic%20action%20shonen%20manga%20scene%20with%20explosive%20battle%20energy%2C%20fiery%20red%20and%20orange%20tones%2C%20dynamic%20speed%20lines%2C%20heroic%20character%20silhouette%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20clean%20dark%20background&width=600&height=800&seq=cat-rexue-featured&orientation=portrait",
  lianai: "https://readdy.ai/api/search-image?query=Romantic%20shoujo%20manga%20scene%20with%20cherry%20blossoms%20falling%2C%20soft%20pink%20and%20peach%20tones%2C%20two%20characters%20holding%20hands%2C%20dreamy%20atmosphere%2C%20gentle%20bokeh%20effect%2C%20clean%20light%20background&width=600&height=800&seq=cat-lianai-featured&orientation=portrait",
  xuanhuan: "https://readdy.ai/api/search-image?query=Fantasy%20xianxia%20manga%20scene%20with%20floating%20mountains%20and%20ancient%20temples%2C%20mystical%20golden%20and%20jade%20tones%2C%20magical%20energy%20spirals%2C%20ethereal%20clouds%2C%20epic%20scale%2C%20clean%20atmospheric%20background&width=600&height=800&seq=cat-xuanhuan-featured&orientation=portrait",
  danmei: "https://readdy.ai/api/search-image?query=Elegant%20BL%20manga%20scene%20with%20two%20beautiful%20male%20characters%20in%20flowing%20traditional%20robes%2C%20soft%20moonlight%2C%20cherry%20blossoms%2C%20ethereal%20blue%20and%20silver%20tones%2C%20poetic%20atmosphere%2C%20clean%20background&width=600&height=800&seq=cat-danmei-featured&orientation=portrait",
  kongbu: "https://readdy.ai/api/search-image?query=Horror%20manga%20scene%20with%20eerie%20shadowy%20atmosphere%2C%20dark%20corridor%20with%20faint%20red%20light%2C%20mysterious%20silhouette%2C%20creepy%20vibe%2C%20monochrome%20with%20crimson%20accents%2C%20clean%20dark%20background&width=600&height=800&seq=cat-kongbu-featured&orientation=portrait",
  gaoxiao: "https://readdy.ai/api/search-image?query=Comedy%20manga%20scene%20with%20funny%20chibi%20characters%20making%20exaggerated%20expressions%2C%20bright%20yellow%20and%20cyan%20tones%2C%20pop%20art%20style%2C%20playful%20vibe%2C%20clean%20white%20background%20with%20comic%20effects&width=600&height=800&seq=cat-gaoxiao-featured&orientation=portrait",
  hanman: "https://readdy.ai/api/search-image?query=Premium%20Korean%20manhwa%20illustration%20with%20stylish%20characters%20in%20modern%20Seoul%20cityscape%2C%20neon%20lights%2C%20romantic%20and%20dramatic%20mood%2C%20cinematic%20composition%2C%20cool%20blue%20and%20pink%20tones%2C%20clean%20urban%20background&width=600&height=800&seq=cat-hanman-featured&orientation=portrait",
  guoman: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20with%20traditional%20Chinese%20elements%20blended%20with%20modern%20aesthetics%2C%20martial%20arts%20scene%2C%20flowing%20ink%20brush%20effects%2C%20red%20and%20gold%20accents%2C%20cultural%20richness%2C%20clean%20background&width=600&height=800&seq=cat-guoman-featured&orientation=portrait",
  riman: "https://readdy.ai/api/search-image?query=Classic%20Japanese%20manga%20illustration%20with%20samurai%20and%20sakura%20motif%2C%20traditional%20Japanese%20aesthetic%2C%20woodblock%20print%20influence%2C%20indigo%20and%20vermillion%20tones%2C%20quiet%20strength%2C%20clean%20background&width=600&height=800&seq=cat-riman-featured&orientation=portrait",
};

const mangaCoverImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20young%20martial%20artist%20red%20robes%20flames%2C%20golden%20crimson%20tones%2C%20clean%20background%20smoke%2C%20detailed%20illustration&width=600&height=800&seq=cat-manga-cover-01&orientation=portrait",
  2: "https://readdy.ai/api/search-image?query=Romantic%20manga%20young%20couple%20school%20uniforms%20cherry%20blossoms%2C%20soft%20pink%20lighting%2C%20dreamy%20atmosphere%2C%20white%20background%2C%20beautiful%20shoujo%20art&width=600&height=800&seq=cat-manga-cover-02&orientation=portrait",
  3: "https://readdy.ai/api/search-image?query=Action%20manga%20silver-haired%20gamer%20black%20jacket%2C%20neon%20gaming%20aesthetics%20blue%20orange%20accents%2C%20dark%20background%20digital%20particles%2C%20dynamic%20shonen&width=600&height=800&seq=cat-manga-cover-03&orientation=portrait",
  4: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fantasy%20manga%20celestial%20being%20white%20red%20silk%20robes%2C%20flower%20petals%20butterflies%2C%20golden%20light%2C%20soft%20gradient%20background%2C%20exquisite&width=600&height=800&seq=cat-manga-cover-04&orientation=portrait",
  5: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark-haired%20hunter%20blue%20eyes%20black%20combat%20outfit%2C%20holographic%20UI%2C%20dark%20gradient%20background%2C%20premium%20manhwa%20style%2C%20cinematic&width=600&height=800&seq=cat-manga-cover-05&orientation=portrait",
  6: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20Chinese%20manga%20futuristic%20soldier%20mechanical%20armor%2C%20dramatic%20orange%20gray%20sky%2C%20sci-fi%20dystopian%2C%20dark%20industrial%20background%2C%20mecha&width=600&height=800&seq=cat-manga-cover-06&orientation=portrait",
  7: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20two%20cultivators%20black%20white%20robes%20guqin%20bamboo%20forest%2C%20moonlight%20mist%2C%20ink%20wash%20style%2C%20serene%20mood&width=600&height=800&seq=cat-manga-cover-07&orientation=portrait",
  8: "https://readdy.ai/api/search-image?query=Japanese%20manga%20young%20swordsman%20burgundy%20hair%20blue%20nichirin%20blade%2C%20water%20breathing%20effect%2C%20dark%20background%20wave%20patterns%2C%20iconic%20shonen&width=600&height=800&seq=cat-manga-cover-08&orientation=portrait",
  9: "https://readdy.ai/api/search-image?query=Romantic%20vampire%20manga%20handsome%20male%20vampire%20crimson%20eyes%20black%20attire%2C%20gentle%20girl%20white%20dress%2C%20gothic%20rose%20garden%2C%20moonlight&width=600&height=800&seq=cat-manga-cover-09&orientation=portrait",
  10: "https://readdy.ai/api/search-image?query=Xianxia%20manga%20young%20cultivator%20mountain%20peak%20mythical%20beasts%2C%20golden%20sunrise%2C%20fantasy%20landscape%2C%20traditional%20Chinese%20ink%20style%20modern%20rendering&width=600&height=800&seq=cat-manga-cover-10&orientation=portrait",
  11: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20spiky%20pink-haired%20teenager%20cursed%20energy%20aura%2C%20urban%20Japanese%20cityscape%20night%2C%20neon%20accents%2C%20dynamic%20shonen%2C%20sharp%20linework&width=600&height=800&seq=cat-manga-cover-11&orientation=portrait",
  12: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20beautiful%20girl%20flawless%20makeup%20two%20handsome%20male%20leads%2C%20Korean%20high%20school%2C%20pastel%20pink%20coral%20tones%2C%20webtoon%20style&width=600&height=800&seq=cat-manga-cover-12&orientation=portrait",
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const tabsRef = useRef<HTMLDivElement>(null);

  const category = mangaCategories.find((c) => c.slug === slug);

  useEffect(() => {
    if (tabsRef.current && slug) {
      const activeTab = tabsRef.current.querySelector(`[data-slug="${slug}"]`);
      if (activeTab) {
        activeTab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    }
  }, [slug]);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16 flex items-center justify-center bg-background-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 font-heading">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryManga = mangaList.filter((m) => m.category === slug);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <section className="pt-6 pb-2 bg-background-50 border-b border-background-200/60">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div
              ref={tabsRef}
              className="flex items-center gap-1.5 overflow-x-auto pb-2 scrollbar-hide"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
              {mangaCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  data-slug={cat.slug}
                  to="/category/all"
                  className={`shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    slug === cat.slug
                      ? "bg-foreground-900 text-white"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900"
                  }`}
                >
                  <i className={`${cat.icon} text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">{category.name}</span>
            </nav>

            <div className="flex flex-col lg:flex-row lg:items-start gap-6">
              <div className="lg:w-[35%]">
                <h1 className="font-serif text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
                  {category.name.split("").map((char, i) => (
                    <span key={i}>{char}{i === 1 ? <br /> : ""}</span>
                  ))}
                </h1>
              </div>
              <div className="lg:w-[65%]">
                <p className="text-sm text-foreground-500 leading-relaxed max-w-lg">
                  {category.description}
                </p>
                <p className="mt-2 text-xs text-foreground-400">
                  共 {categoryManga.length} 部漫画
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            {categoryManga.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="md:col-span-1">
                  <Link
                    to={`/article/${categoryManga[0].id}`}
                    className="group block relative aspect-[4/5] rounded-2xl overflow-hidden bg-foreground-900 cursor-pointer"
                  >
                    <img
                      src={categoryCoverImages[slug] || categoryCoverImages.rexue}
                      alt={category.name}
                      title={`${category.name} - 汗汗漫画`}
                      className="absolute inset-0 w-full h-full object-cover object-top opacity-50 group-hover:opacity-70 transition-opacity duration-500"
                    />
                    <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                      <h2 className="text-xl md:text-2xl font-black text-white font-heading">
                        推荐 {category.name}
                      </h2>
                      <p className="mt-3 text-sm text-white/70">
                        {categoryManga[0].title}
                      </p>
                      <span className="mt-6 inline-block px-6 py-2.5 bg-white text-foreground-900 text-sm font-semibold rounded-full whitespace-nowrap">
                        立即阅读
                      </span>
                    </div>
                  </Link>
                </div>

                {categoryManga.slice(1, 7).map((manga) => (
                  <Link
                    key={manga.id}
                    to={`/article/${manga.id}`}
                    className="group block bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <div className="relative p-4">
                      <div className="flex items-start gap-1.5 mb-3">
                        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                          <i className="ri-time-line text-[10px]"></i>
                          {manga.status}
                        </span>
                      </div>
                      <div className="aspect-[3/4] rounded-xl overflow-hidden mb-4">
                        {mangaCoverImages[manga.id] && (
                          <img
                            src={mangaCoverImages[manga.id]}
                            alt={manga.title}
                            title={`${manga.title} - 汗汗漫画`}
                            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                          />
                        )}
                      </div>
                      <h3 className="text-lg font-bold text-foreground-900 font-heading leading-tight truncate">
                        {manga.title}
                      </h3>
                      <p className="mt-1.5 text-xs text-foreground-500 truncate">
                        {manga.latestChapter}
                      </p>
                      <p className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                        <span>{manga.author}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                          {manga.rating}
                        </span>
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            )}

            {categoryManga.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画，敬请期待~</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": `${category.name} - 汗汗漫画`,
            "description": `${category.description}。汗汗漫画${category.name}专区，每日更新优质${category.name}资源。`,
            "url": 'http://i0767.com/category/all',
            "inLanguage": "zh-Hans",
            "isPartOf": {
              "@type": "WebSite",
              "name": "汗汗漫画",
              "url": "http://i0767.com/"
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "http://i0767.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": category.name,
                "item": 'http://i0767.com/category/all'
              }
            ]
          }),
        }}
      />
    </>
  );
}